import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUserProjectPreference = async ({
  preference,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const apiPath = 'user/projects/preferences';

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: preference,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
